import React, { PropsWithChildren, useContext, useState } from 'react';
import { CustomText } from '@/components/CustomText';
import { FlexAlignType, ScrollView, ScrollViewProps, StyleProp, StyleSheet, View, ViewStyle } from 'react-native';
import { Text } from 'react95-native-rabbl';
import { CustomDivider } from "@/components/CustomDivider";
import { Link } from 'expo-router';
import * as AppConstants from '@/utilities/AppConstants';
import * as AppUtilities from '@/utilities/AppUtilities';
import * as AppUtils from '@/utilities/AppUtils';
import { BasicScrollView } from "@/components/BasicScrollView";
import { CommunityMembership } from '@/types/community_membership';
import { RabblSearchResult } from "@/components/RabblSearchResult";
import { AppText } from '@/components/AppText';
import { Button, Panel } from 'react95-native-rabbl';
import { UNKNOWN_COMMUNITY } from '@/types/community';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: "90%",
    gap: 20,
    alignItems: 'center',
    alignSelf: 'center',
  },
});

interface Props {
  communityMemberships: CommunityMembership[],
  showDivider?: boolean,
  align?: FlexAlignType,
  currentCommunityMembership?: CommunityMembership,
  title?: string,
  customLink?: string,
};

export function UserRabbls({
  communityMemberships,
  showDivider = true,
  align = "center",
  currentCommunityMembership = undefined,
  title = "Rabbls you're in",
  customLink = undefined,
}: Props) : React.ReactNode {
  return (
    <View style={AppConstants.STYLES.padding20gap20}>
      <View style={{ width: "100%", alignItems: align }}>
        <CustomText>{title}</CustomText>
      </View>
      {
        communityMemberships && communityMemberships.length > 0 ?
            <>
              {communityMemberships.map((communityMembership, index) =>
                <View key={communityMembership.uniqueid} style={{ width: "100%", alignItems: align }}>
                  {
                    showDivider && (
                      <>
                        <View style={AppConstants.STYLES.padding5} />
                        <CustomDivider fullWidth={true} marginBottom={true} />
                      </>
                    )
                  }
                  <View style={AppConstants.STYLES.padding5} />
                  <RabblSearchResult
                    community={communityMembership.community ?? UNKNOWN_COMMUNITY}
                    community_membership={communityMembership}
                    customLink={customLink ? customLink : (communityMembership.uniqueid == currentCommunityMembership?.uniqueid ? "/info" : undefined)}
                  />
                </View>
              )}
            </>
          :
            <>
              <AppText>You're not a member of any Rabbls yet.</AppText>
              <Link href="/findrabbl" asChild className={"nontext"}><Button>Search Rabbls</Button></Link>
            </>
      }
    </View>
  );
};
